import React from 'react';
import { subscribeGallery } from '../lib/gallery';
import { currentDevice, observeDevice } from '../lib/layout';

// Startseite: ein grosses Bild oben, darunter die uebrigen nebeneinander.
// Welche das sind, verwaltet der Admin-Bereich unter 'Startseite'; die
// Reihenfolge entscheidet, welches Bild das grosse ist.
class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // null heisst: noch nichts geladen. Bis dahin bleibt die Flaeche leer,
      // statt kurz fremde Bilder zu zeigen.
      items: null,
      columns: null,
      geraet: currentDevice()
    }
  }

  componentDidMount() {
    var that = this;
    this.disposeDevice = observeDevice(function (geraet) {
      that.setState({ geraet: geraet });
    });
    this.unsubscribe = subscribeGallery(function (gallery) {
      that.setState({
        items: gallery.landing.items,
        columns: gallery.landing.columns
      });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    if (this.disposeDevice) {
      this.disposeDevice();
    }
  }

  render() {
    if (!this.state.items) {
      return <div class='fullwidthcontainer' />;
    }
    var gross = this.state.items[0];
    var klein = this.state.items.slice(1);
    var spalten = this.state.columns[this.state.geraet];
    // Das grosse Bild ist das Erste, was die Seite zeigt: nicht verzoegert
    // laden. Die kleinen stehen darunter und kommen beim Scrollen.
    var list = klein.map(function (item) {
      return <img src={item.src} alt='' class='smallimage' key={item.src}
        loading='lazy' decoding='async' />;
    });

    return (
      <div class='fullwidthcontainer'>
        {gross && (
          <div class='fullwidthcontainer'>
            <img src={gross.src} alt='Augenstern Schmuck' class='bigimage' />
          </div>
        )}
        <div class='fullwidthcontainer' style={{ '--spalten': spalten }}>
          {list}
        </div>
      </div>
    );
  }
}

export default (Landing);
